import _extends from "@babel/runtime/helpers/extends";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
/**
 * `MenuDivider` is a part of [Menu](#!/Menu) component.
 * @since 0.0.57
 */

const MenuDivider = ({
  baseClassName,
  className,
  ...props
}) => /*#__PURE__*/React.createElement("div", _extends({
  className: classNames(baseClassName, className),
  role: "separator"
}, props));

MenuDivider.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
MenuDivider.defaultProps = {
  className: null,
  baseClassName: "".concat(CLS_PREFIX, "menu__divider")
};
export default MenuDivider;